import { useContextHook } from "../../Context/ContextOPen";
import { partnersOfSuccessList } from "../../Context/Lists";
import { Container } from "../../components";
import { useEffect, useRef, useState } from "react";
import { content } from "../../lang/useLang";

const Partners = () => {
  const { direction } = useContextHook();
  const [isVisible, setIsVisible] = useState(false);
  const [animatedElements, setAnimatedElements] = useState({
    title: false,
    logos: Array(partnersOfSuccessList.length).fill(false),
    footer: false,
  });

  const partnersRef = useRef(null);

  // تتبع ظهور القسم
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // تفعيل الأنيميشن بالتسلسل
          setTimeout(
            () => setAnimatedElements((prev) => ({ ...prev, title: true })),
            200
          );

          // تفعيل الشعارات بشكل تدريجي
          partnersOfSuccessList.forEach((_, index) => {
            setTimeout(() => {
              setAnimatedElements((prev) => ({
                ...prev,
                logos: prev.logos.map((item, i) => (i === index ? true : item)),
              }));
            }, 400 + index * 60);
          });

          setTimeout(
            () => setAnimatedElements((prev) => ({ ...prev, footer: true })),
            1000
          );
        }
      },
      { threshold: 0.3 }
    );

    if (partnersRef.current) {
      observer.observe(partnersRef.current);
    }

    return () => {
      if (partnersRef.current) {
        observer.unobserve(partnersRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={partnersRef}
      className=" relative overflow-hidden transition-all duration-1000"
      style={{ direction }}
    >
      {/* تأثيرات الخلفية المحسنة */}
      <div className="absolute inset-0 overflow-hidden">
        {/* أشكال هندسية عائمة */}
        <div className="absolute top-20 left-10 w-16 h-16 bg-slate-500/5 rounded-full animate-float-slow"></div>
        <div
          className="absolute top-40 right-20 w-12 h-12 bg-slate-400/5 rounded-full animate-float-medium"
          style={{ animationDelay: "2s" }}
        ></div>
        <div
          className="absolute bottom-32 left-1/4 w-20 h-20 bg-slate-500/3 rounded-full animate-float-slow"
          style={{ animationDelay: "4s" }}
        ></div>
        <div
          className="absolute bottom-20 right-32 w-14 h-14 bg-slate-400/4 rounded-full animate-float-medium"
          style={{ animationDelay: "1s" }}
        ></div>

        {/* خطوط متقاطعة */}
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-500/10 to-transparent animate-scan-horizontal"></div>
        <div
          className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-400/10 to-transparent animate-scan-horizontal"
          style={{ animationDelay: "2s" }}
        ></div>

        {/* شبكة خلفية */}
        <div className="absolute inset-0 opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `radial-gradient(circle at 25% 25%, rgba(100, 116, 139, 0.2) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(71, 85, 105, 0.2) 0%, transparent 50%)`,
              backgroundSize: "50px 50px",
            }}
          ></div>
        </div>
      </div>

      <br />
      <Container className="relative z-10">
        <div className="min-h-screen flex items-center justify-center">
          <div className="w-full">
            {/* العنوان مع أنيميشن محسنة */}
            <div
              className={`text-center mb-10 transition-all duration-1000 ${
                isVisible && animatedElements.title
                  ? "opacity-100 translate-y-0 scale-100"
                  : "opacity-0 translate-y-10 scale-95"
              }`}
            >
              <h1
                className="text-4xl md:text-5xl font-bold mb-6 relative inline-block"
                style={{
                  background:
                    "linear-gradient(135deg, #cbd5e1 0%, #94a3b8 25%, #475569 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                {content["partners_of_success"]}
                {/* تأثير توهج تحت النص */}
                <div className="absolute -inset-4 bg-gradient-to-r from-slate-500/10 to-slate-600/10 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-1000"></div>
              </h1>

              <div
                className={`w-32 h-1.5 bg-gradient-to-r from-slate-400 to-slate-600 mx-auto rounded-full mb-6 shadow-lg shadow-slate-500/30 transition-all duration-1000 delay-200 ${
                  isVisible && animatedElements.title
                    ? "opacity-100 translate-x-0 scale-x-100"
                    : "opacity-0 translate-x-10 scale-x-0"
                }`}
              ></div>

              <p
                className={`text-slate-300 text-xl max-w-2xl mx-auto leading-relaxed transition-all duration-1000 delay-300 ${
                  isVisible && animatedElements.title
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-6"
                }`}
              >
                {content["desc_partners"]}
              </p>
            </div>

            {/* شبكة الشعارات مع أنيميشن محسنة */}
            <div
              className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 transition-all duration-1000 ${
                isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"
              }`}
            >
              {partnersOfSuccessList.map((logo, index) => (
                <div key={index} className="group relative">
                  {/* تأثير خلفي للبطاقة */}
                  <div className="absolute -inset-1 bg-gradient-to-r from-slate-600 to-slate-500 rounded-2xl blur opacity-0 group-hover:opacity-30 transition duration-500 group-hover:scale-105"></div>

                  {/* البطاقة الرئيسية */}
                  <div
                    className={`relative bg-gradient-to-br from-white/10 to-white/5 rounded-xl overflow-hidden border border-slate-500/30 backdrop-blur-xl shadow-lg hover:shadow-xl transition-all duration-500 group-hover:-translate-y-1 group-hover:scale-105 group-hover:border-slate-400/50 ${
                      animatedElements.logos[index]
                        ? "opacity-100 translate-y-0 scale-100"
                        : "opacity-0 translate-y-8 scale-95"
                    }`}
                    style={{
                      transitionDelay: `${index * 60}ms`,
                    }}
                  >
                    <div className="p-4">
                      <div className="relative">
                        {/* تأثير إشعاعي */}
                        <div className="absolute -inset-3 bg-gradient-to-r from-slate-600/10 to-slate-500/10 rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-all duration-700"></div>

                        {/* الشعار */}
                        <img
                          src={logo}
                          alt="Partner"
                          className="relative w-full h-16 object-contain invert opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 z-10"
                        />

                        {/* تأثير فوق الشعار */}
                        <div className="absolute inset-0 bg-gradient-to-br from-slate-600/5 to-slate-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-lg"></div>
                      </div>
                    </div>

                    {/* نقاط زخرفية */}
                    <div className="absolute -top-1 -right-1 w-2 h-2 bg-slate-400 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    <div
                      className="absolute -bottom-1 -left-1 w-2 h-2 bg-slate-500 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                      style={{ animationDelay: "1s" }}
                    ></div>

                    {/* تأثير اهتزاز عند الظهور */}
                    <div
                      className={`absolute inset-0 rounded-xl border-2 border-transparent ${
                        animatedElements.logos[index]
                          ? "animate-partner-glow"
                          : ""
                      }`}
                    ></div>
                  </div>

                  {/* خط متحرك تحت البطاقة */}
                  <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-slate-400 to-slate-600 group-hover:w-2/3 transition-all duration-500 rounded-full"></div>
                </div>
              ))}
            </div>

            {/* نص إضافي في الأسفل */}
            <div
              className={`text-center mt-10 transition-all duration-1000 ${
                isVisible && animatedElements.footer
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
            >
              <p className="text-slate-400 text-lg max-w-3xl mx-auto leading-relaxed mb-6">
                {content["desc_partners2"]}
              </p>

              {/* شريط إحصائي متحرك */}
              {/* <div className="flex flex-col sm:flex-row justify-center items-center gap-4 md:gap-8">
                <div className="flex items-center gap-2 text-slate-300 group">
                  <div className="relative">
                    <div className="w-3 h-3 bg-slate-400 rounded-full animate-pulse group-hover:scale-150 transition-transform duration-300"></div>
                    <div className="absolute inset-0 w-3 h-3 bg-slate-400 rounded-full animate-ping opacity-0 group-hover:opacity-100"></div>
                  </div>
                  <span className="text-sm font-medium">
                    {partnersOfSuccessList.length}+ شريك موثوق
                  </span>
                </div>

                <div className="hidden sm:block w-1 h-1 bg-slate-600 rounded-full"></div>

                <div className="flex items-center gap-2 text-slate-300 group">
                  <div className="relative">
                    <div
                      className="w-3 h-3 bg-slate-400 rounded-full animate-pulse group-hover:scale-150 transition-transform duration-300"
                      style={{ animationDelay: "0.5s" }}
                    ></div>
                    <div
                      className="absolute inset-0 w-3 h-3 bg-slate-400 rounded-full animate-ping opacity-0 group-hover:opacity-100"
                      style={{ animationDelay: "0.5s" }}
                    ></div>
                  </div>
                  <span className="text-sm font-medium">
                    سنوات من التعاون الناجح
                  </span>
                </div>

                <div className="hidden sm:block w-1 h-1 bg-slate-600 rounded-full"></div>

                <div className="flex items-center gap-2 text-slate-300 group">
                  <div className="relative">
                    <div
                      className="w-3 h-3 bg-slate-400 rounded-full animate-pulse group-hover:scale-150 transition-transform duration-300"
                      style={{ animationDelay: "1s" }}
                    ></div>
                    <div
                      className="absolute inset-0 w-3 h-3 bg-slate-400 rounded-full animate-ping opacity-0 group-hover:opacity-100"
                      style={{ animationDelay: "1s" }}
                    ></div>
                  </div>
                  <span className="text-sm font-medium">مشاريع ناجحة</span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </Container>

      {/* الأنيميشن المخصصة */}
      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes orbital-1 {
          0%,
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(50px, -30px) rotate(90deg);
          }
          50% {
            transform: translate(0, -60px) rotate(180deg);
          }
          75% {
            transform: translate(-50px, -30px) rotate(270deg);
          }
        }
        @keyframes orbital-2 {
          0%,
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(-40px, 20px) rotate(-90deg);
          }
          50% {
            transform: translate(0, 40px) rotate(-180deg);
          }
          75% {
            transform: translate(40px, 20px) rotate(-270deg);
          }
        }
        @keyframes pulse-glow {
          0%,
          100% {
            opacity: 0.1;
            transform: scale(1);
          }
          50% {
            opacity: 0.2;
            transform: scale(1.1);
          }
        }
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        @keyframes twinkle {
          0%,
          100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.2);
          }
        }
        @keyframes scan-horizontal {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        @keyframes float-slow {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-15px) rotate(120deg);
          }
          66% {
            transform: translateY(8px) rotate(240deg);
          }
        }
        @keyframes float-medium {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-12px) rotate(-120deg);
          }
          66% {
            transform: translateY(6px) rotate(-240deg);
          }
        }
        @keyframes partner-glow {
          0% {
            border-color: transparent;
            box-shadow: 0 0 0 0 rgba(148, 163, 184, 0.7);
          }
          50% {
            border-color: rgba(148, 163, 184, 0.3);
            box-shadow: 0 0 0 8px rgba(148, 163, 184, 0);
          }
          100% {
            border-color: transparent;
            box-shadow: 0 0 0 0 rgba(148, 163, 184, 0);
          }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .animate-orbital-1 {
          animation: orbital-1 20s ease-in-out infinite;
        }
        .animate-orbital-2 {
          animation: orbital-2 25s ease-in-out infinite;
        }
        .animate-pulse-glow {
          animation: pulse-glow 8s ease-in-out infinite;
        }
        .animate-shimmer {
          animation: shimmer 3s ease-in-out infinite;
        }
        .animate-twinkle {
          animation: twinkle 3s ease-in-out infinite;
        }
        .animate-scan-horizontal {
          animation: scan-horizontal 4s linear infinite;
        }
        .animate-float-slow {
          animation: float-slow 8s ease-in-out infinite;
        }
        .animate-float-medium {
          animation: float-medium 6s ease-in-out infinite;
        }
        .animate-partner-glow {
          animation: partner-glow 1.5s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default Partners;
